import React, { useContext } from "react";
import AddAdminBanks from "./addAdminBank";
import AdminBankTable from "./AdminBankTable";
import Pagination from "../../Pagination";
import AdminContext from "./AdminDashContext";
import { Link } from "react-router-dom";


export default function AdminBanksFun() {
    const { allBanks, addAdminBank, updateAdminBank, deleteAdminBank, editBank, bankToEdit, setBankToEdit, paginate, currentPage, postsPerPage, newBanksData}=useContext(AdminContext)
    const shouldPaginate = allBanks.length > 4
    const displayedBanks = shouldPaginate ? newBanksData : allBanks
  
    return (
        <div className=" mb-16">
            <h4>BANKS</h4>            
            <Link to="/adminDash/communicate/bank_owners">bankOwners</Link>
            <AddAdminBanks onAdd={addAdminBank} onEdit={updateAdminBank} BankToEdit={bankToEdit} setBankToEdit={setBankToEdit} />
            <AdminBankTable onDelete={deleteAdminBank} BanksData={displayedBanks} onEdit={editBank} />
            {shouldPaginate ? <Pagination postsPerPage={postsPerPage} totalPosts={allBanks.length} currentPage={currentPage} paginate={paginate} /> : null}
        </div>
    )
}